'use client'
import Link from 'next/link'
import { useEffect } from 'react';
export default function NotFound() {
    useEffect(() => {
        window.location.href = '/';
    }, []);
    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
                <h2 className="text-2xl font-bold mb-4">找不到頁面</h2>
                <p className="mb-4">抱歉，您要找的頁面不存在。</p>
                <Link
                    href="/"
                    className="text-blue-500 hover:text-blue-700 underline"
                >
                    返回首頁
                </Link>
            </div>
        </div>
    )
} 